import { useState } from 'react'
import { useModalStore } from '@/stores/useModalStore'
import { Button } from '@/components/ui'
import styles from './StatusChangeModal.module.css'

interface StatusChangeModalProps {
    orderId: string
    newStatus: string
    statusLabel: string
    onConfirm: (data: { note: string; tracking_number: string }) => void
    handleClose?: () => void
}

function getConfirmVariant(status: string): 'danger' | 'success' | 'primary' {
    if (status === 'cancelled') return 'danger'
    if (status === 'delivered') return 'success'
    return 'primary'
}

export function StatusChangeModal({
    orderId: _orderId,
    newStatus,
    statusLabel,
    onConfirm,
}: StatusChangeModalProps) {
    const { closeModal } = useModalStore()
    const [note, setNote] = useState('')
    const [trackingNumber, setTrackingNumber] = useState('')

    const confirmVariant = getConfirmVariant(newStatus)

    function handleConfirm() {
        onConfirm({ note, tracking_number: trackingNumber })
        closeModal()
    }

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>
                Cambiar estado a: <span className={styles.statusLabel}>{statusLabel}</span>
            </h3>

            <div className={styles.field}>
                <label className={styles.label} htmlFor="status-note">
                    Nota (opcional)
                </label>
                <textarea
                    id="status-note"
                    className={styles.textarea}
                    rows={3}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Agrega una nota sobre este cambio..."
                />
            </div>

            {newStatus === 'shipped' && (
                <div className={styles.field}>
                    <label className={styles.label} htmlFor="tracking-number">
                        Número de seguimiento
                    </label>
                    <input
                        id="tracking-number"
                        className={styles.input}
                        type="text"
                        value={trackingNumber}
                        onChange={(e) => setTrackingNumber(e.target.value)}
                        placeholder="Ej: PE123456789"
                    />
                </div>
            )}

            <div className={styles.actions}>
                <Button variant="secondary" onClick={closeModal}>
                    Cancelar
                </Button>
                <Button variant={confirmVariant} onClick={handleConfirm}>
                    Confirmar
                </Button>
            </div>
        </div>
    )
}
